import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Gym Ceylon and by choosing the right plan and program I already achieved my ideal body!",
    name: 'MATHEW HENDRICKSON',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'Working with Gym Ceylon and Coach Clint was an excellent experience. They helped me with my core strength and back flexibility.',
    name: 'JOHN KEVIN',
    status: 'COACH'
  },
  {
    image : image3,
    review:'Gym Ceylon, thank you so much for everything. I used to not even be able to make it up a staircase without losing my breath.',
    name: 'FRANKLIN',
    status: "CUSTOMER"
  }
];
